import type { Moment } from 'moment';

export type AnyDate = string | Date | Moment;
export const STANDARD_DATE_FORMAT = 'L';
export const STANDARD_TIME_FORMAT = 'LT';
export const HUMAN_READABLE_DATE_FORMAT = 'LL';
export const HUMAN_READABLE_DATE_TIME_FORMAT = 'LLL';
